import { WhatMakesUsDifferentSingleComponentProps } from "./WhatMakesUsDifferent";

import { CgProfile } from "react-icons/cg";
import { IoMdPhonePortrait } from "react-icons/io";
import { PiMedalMilitary } from "react-icons/pi";
import { PiGraphThin } from "react-icons/pi";
import { IoIosInfinite } from "react-icons/io";
import { RiHeartsLine } from "react-icons/ri";

const forParticipants: WhatMakesUsDifferentSingleComponentProps[] = [
  {
    icon: <CgProfile />,
    header: "Personal Fundrasing Page",
    subText: "Track your progress, share your link, and celebrate your empact!",
  },
  {
    icon: <PiMedalMilitary />,
    header: "Fun and Motivating",
    subText: "Upload your photo and compete with your peers!",
  },
  {
    icon: <IoMdPhonePortrait />,
    header: "Optimized for Mobile",
    subText: "Manage your fundraisers and share links from any device.",
  },
  {
    icon: <PiGraphThin />,
    header: "Easy Sharing Tools",
    subText:
      "Quickly post to social media or send messages to family and friends!",
  },
  {
    icon: <IoIosInfinite />,
    header: "No Minimums or Quotas",
    subText:
      "Every bit counts - contribute at your own pace with zero pressure or required goals to meet.",
  },
  {
    icon: <RiHeartsLine />,
    header: "Support Without Selling",
    subText: "Give your supporters the option to purchase or donate!",
  },
];

export default forParticipants;
